var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{class:`badge badge-warning help`},[(_vm.img)?_c('img',{attrs:{"src":require(`@/assets/icons/${_vm.img}.png`),"alt":"ireal badge"}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }